const languageCode = 'en-US';           // Ref. https://github.com/libyal/libfwnt/wiki/Language-Code-identifiers
const currencyCode = 'USD';             // Ref. https://www.currency-iso.org/en/home/tables/table-a1.html

export const formatDefaultCurrency = ({
  value,
  language = languageCode,
  currency = currencyCode
}) => {
  const fn = new Intl.NumberFormat(language, { style: 'currency', currency });
  return fn.format(value);
}

const excelDateToJSDate = (serial) => {
  const utcDays = Math.floor(serial - 25569);
  const utcValue = utcDays * 86400; 
  const dateInfo = new Date(utcValue * 1000); 
  return dateInfo.toISOString().split('T')[0]; // returns 'YYYY-MM-DD'
}

export default excelDateToJSDate;
